import {
  getObject,
  getOptionalObject,
  getBoolean,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "./code";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";

export interface BasicQuestionDetailsDTO {
  questionCode: CodeDTO;
  question?: SurveyLocalizedTextDTO | null;
  questionDescription?: SurveyLocalizedTextDTO | null;
  isMandatory: boolean;
  isVisibleByDefault: boolean;
}

export class BasicQuestionDetails {
  readonly isBasicQuestionDetailsBasicQuestionDetails: boolean = true;

  readonly questionCode: Code;
  readonly question: SurveyLocalizedText | null;
  readonly questionDescription: SurveyLocalizedText | null;
  readonly isMandatory: boolean;
  readonly isVisibleByDefault: boolean;


  constructor(
  questionCode: Code, 
  question: SurveyLocalizedText | null = null, 
  questionDescription: SurveyLocalizedText | null = null, 
  isMandatory: boolean, 
  isVisibleByDefault: boolean
  ) {
    this.questionCode = questionCode;
    this.question = question;
    this.questionDescription = questionDescription;
    this.isMandatory = isMandatory;
    this.isVisibleByDefault = isVisibleByDefault;
  }

  static fromDTO(dto: BasicQuestionDetailsDTO): BasicQuestionDetails {
    const questionCode = Code.fromDTO(getObject(dto, "questionCode", InvalidBasicQuestionDetailsQuestionCodeError));
    let question = getOptionalObject(dto, "question");
    if(question !== undefined && question !== null) {
      question = SurveyLocalizedText.fromDTO(getObject(dto, "question", InvalidBasicQuestionDetailsQuestionError));
    }
    let questionDescription = getOptionalObject(dto, "questionDescription");
    if(questionDescription !== undefined && questionDescription !== null) {
      questionDescription = SurveyLocalizedText.fromDTO(getObject(dto, "questionDescription", InvalidBasicQuestionDetailsQuestionDescriptionError));
    }
    const isMandatory = getBoolean(dto, "isMandatory", InvalidBasicQuestionDetailsIsMandatoryError);
    const isVisibleByDefault = getBoolean(dto, "isVisibleByDefault", InvalidBasicQuestionDetailsIsVisibleByDefaultError);
    return new BasicQuestionDetails(
      questionCode,
      question,
      questionDescription,
      isMandatory,
      isVisibleByDefault
    );
  }

  toDTO(): BasicQuestionDetailsDTO {
    const dto: BasicQuestionDetailsDTO = {
        questionCode: this.questionCode.toDTO(),
        isMandatory: this.isMandatory,
        isVisibleByDefault: this.isVisibleByDefault
    };
    if (this.question !== undefined && this.question !== null){
      dto.question = this.question.toDTO();
    }
    if (this.questionDescription !== undefined && this.questionDescription !== null){
      dto.questionDescription = this.questionDescription.toDTO();
    }
    return dto;
  }
  }

BasicQuestionDetails.prototype.toString = function toString(): string {
  return `BasicQuestionDetails(questionCode='${this.questionCode}',question='${this.question}',questionDescription='${this.questionDescription}',isMandatory='${this.isMandatory}',isVisibleByDefault='${this.isVisibleByDefault}')`;
};

export class InvalidBasicQuestionDetailsError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBasicQuestionDetailsError";
  }
}
export class InvalidBasicQuestionDetailsQuestionCodeError extends InvalidBasicQuestionDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBasicQuestionDetailsQuestionCodeError";
  }
}

export class InvalidBasicQuestionDetailsQuestionError extends InvalidBasicQuestionDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBasicQuestionDetailsQuestionError";
  }
}

export class InvalidBasicQuestionDetailsQuestionDescriptionError extends InvalidBasicQuestionDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBasicQuestionDetailsQuestionDescriptionError";
  }
}

export class InvalidBasicQuestionDetailsIsMandatoryError extends InvalidBasicQuestionDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBasicQuestionDetailsIsMandatoryError";
  }
}

export class InvalidBasicQuestionDetailsIsVisibleByDefaultError extends InvalidBasicQuestionDetailsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidBasicQuestionDetailsIsVisibleByDefaultError";
  }
}
